<template>
  <v-row justify="center">
    <v-dialog v-if="!loadingdata" v-model="userlogdetailview" persistent max-width="1000">

      <div class="">
        <div class="v-card--material mt-4 v-card v-sheet theme--light">
          
          <div class="v-card__title align-start">
            <div class="overflow-hidden mt-n9 transition-swing v-card--material__sheet v-sheet theme--light elevation-6 rounded" :class="userlogdetails.colorName" style="max-width: 100%; width: 100%;">
              <div class="pa-8 white--text">
                <div class="text-h4 font-weight-light"> <v-icon color="white">{{ userlogdetails.icon }}</v-icon>  {{ userlogdetails.name | translate }} </div>
                <div class="white--text subtitle-2 font-weight-medium ms-9">
                  {{userlogdetails.stored_at}}
                </div>
              </div>
            </div>
          </div>
                
          <div class="v-card__text">

            <div class="v-data-table theme--light">
              <div class="v-data-table__wrapper">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Key
                        </th>
                        <th class="text-left">
                          Description
                        </th>
                        <th class="text-left">
                          Value
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(itemval,itemkey) in userlogdetails.meta_data"
                        :key="itemkey"
                      >
                        <td>{{ userlogdetails.log_type+'.'+userlogdetails.statement_query+'.'+itemkey+'.key'| translate }}</td>
                        <td>{{ userlogdetails.log_type+'.'+userlogdetails.statement_query+'.'+itemkey+'.description'| translate }}</td>
                        <td>
                          <div v-html="extractVal(itemval)"></div>
                          <!-- <div v-html="extracthtml(itemval)"></div> -->
                        </td>
          
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="closeBox">{{ 'Close' | translate }}</v-btn>
            <!-- <v-btn color="green darken-1" text @click="handleAction">{{ userlogdetails.name | translate }}</v-btn> -->
          </v-card-actions>
        </div>
      </div>

    </v-dialog>

    <v-overlay :absolute="absolute" :value="(loadingdata && userlogdetailview)">
      <v-layout row justify-center v-if="loadingdata">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MeaDataDetailView",
  computed: {
    ...mapGetters(["loadingdata"])
  },
  methods: {
    closeBox() {
      this.$emit("closeMetaView");
    },
    extracthtml(val){
      if (typeof val === 'object') {
          //check if any links present
          if(this.isValidUrl(val)){
            let links = '';
            Object.values(val).forEach(element => {
                  links += '<p><a href="'+element+'" target="_blank"> '+element+' </a></p>';
            });
            return links; 
          }
          else{
            let blocks = '';
           
            if (typeof val === 'object') {
              Object.keys(val).forEach(key => {
                blocks =  (key, val[key]) +', '+ blocks;
              });  

              if (typeof blocks === 'object') {
                  // blocks += this.extracthtml(val);
                  blocks = val;
              }
            }
            else{
              blocks = val;
            }
            return blocks;
          }  
           
      }
      else if(Array.isArray(val)){
        let result = '';
        for (const prop in val) {
            const value = val[prop];
            if (typeof value === 'object') {
                result = this.extractVal(value);
                // result = (this.extractVal(value)) +', '+ result; // <- recursive call
            }
            else {
                result = (value) +', '+ result;
            }
        }
        return result;
      }
      else{
        return val;
      }

      // return link;
    },
    isValidUrl(str) {
      let rawHtml='';
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      if(url.protocol === "http:" || url.protocol === "https:"){
        rawHtml +=  '<span><a href="'+str+'">'+str+'</a></span>'
        return rawHtml;
      }
      return false;
    },
    extractVal(val) {
      let result = '';
      if(typeof val === 'object' && !Array.isArray(val) && val !== null){
        Object.keys(val).forEach(key => {
          result =  (key, val[key]) +', '+ result;
        });
      }
      else if(Array.isArray(val)){
        if(this.isValidUrl(val)){
          let links = '';
          Object.values(val).forEach(element => {
                links += '<p><a href="'+element+'" target="_blank"> '+element+' </a></p>';
          });
          return links; 
        }
        for (const prop in val) {
            const value = val[prop];
            if (typeof value === 'object') {
                result = (this.extractVal(value)) +', '+ result; // <- recursive call
            }
            else {
                result = (value) +', '+ result;
            }
        }
      }
      else{
        result = val;
      }
      return result;
    },
  },
  data: () => ({
    absolute: false,
    headers: [  
        { text: "Key", value: "key" },  
        { text: "Description", value: "description" },  
        { text: "Value", value: "value" }         
      ]     
  }),  
  props: {
    userlogdetailview: Boolean,
    userlogdetails: Object,
    closestatus: Boolean
  }
};
</script>

<style scoped>
.parent-card-container{
  background-color: rgb(250, 250, 250) !important;
}

.inner-card{
  padding: 40px;
  margin: 20px;
}

.dark-green{
  background-color: #008000;
}

.navy-blue{
  background-color: #01579B;
}

.olive{
  background-color: #808000;
}

.teal{
  background-color: #00897B;
}
</style>